import React from 'react'
import PitchDeckTableRowsView from './pitch-deck-table-rows-view'

const PitchDeckTableView = ({ data, rowArray }) => {
  return (
    <table className='idea-checker-table'>
      {/* form fields */}
      <tbody>
        <PitchDeckTableRowsView data={data} rowArray={rowArray} />
      </tbody>
    
    </table>
  )
}

export default PitchDeckTableView